<template>
	<el-dialog :visible.sync="dialogVisible" :title="title" width="500px" @close="handleClose">
		<el-form :model="form" ref="formRef" label-width="100px">
			<el-form-item v-if="type === 0" label="车牌号">
				<el-input v-model="form.carNo" />
			</el-form-item>
			<el-form-item v-if="type === 1" label="旧车牌号">
				<el-input v-model="form.oldCarNo" disabled />
			</el-form-item>
			<el-form-item v-if="type === 1" label="新车牌号">
				<el-input v-model="form.newCarNo" />
			</el-form-item>
			<el-form-item label="人员编号">
				<el-input v-model="form.userNo" />
			</el-form-item>
		</el-form>
		<span slot="footer">
			<el-button @click="handleClose">取消</el-button>
			<el-button type="primary" @click="handleSubmit" :loading="loading">提交</el-button>
		</span>
	</el-dialog>
</template>

<script>
	import { randomDecimal, generateSign } from '@/api/common/parkAreaApi'
	import axios from 'axios'
	export default {
		props: {
			visible: {
				type: Boolean,
				default: false
			},
			chargeData: {
				type: Object,
				default: null
			}
		},
		data() {
			return {
				loading: false,
				dialogVisible: false,
				title: '新增月租车',
				type: 0,
				form: {
					carNo: '',
					userNo: '',
					appid: "ym6c157cca12185f0d",
					version: "v1.0",
					parkKey: "eegy2vge"
				}
			}
		},
		watch: {
			visible(val) {
				this.dialogVisible = val
				if (val && this.chargeData) {
					this.title = '修改月租车'
					this.type = 1
					this.form.oldCarNo = this.chargeData.carNo || ''
					this.form.userNo = this.chargeData.userNo || ''
				}
			},
			dialogVisible(val) {
				this.$emit('update:visible', val)
			}
		},
		methods: {
			handleClose() {
				this.dialogVisible = false
				this.title = '新增月租车'
				this.type = 0
				this.form = {
					carNo: '',
					userNo: '',
					appid: "ym6c157cca12185f0d",
					version: "v1.0",
					parkKey: "eegy2vge"
				}
				this.$refs.formRef && this.$refs.formRef.resetFields()
			},
			async handleSubmit() {
				try {
					await this.$refs.formRef.validate()
				} catch {
					return
				}
				this.loading = true
				try {
					const rand = await randomDecimal()
					this.form.rand = rand.toString()
					this.$delete(this.form, 'sign')
					this.form.sign = await generateSign(this.form)
					let res = null
					if(this.type === 1) {
						this.$delete(this.form, 'carNo')
						res = await axios.post('/Api/Inform/EditMthCar', this.form)
					}else {
						res = await axios.post('/Api/Inform/AddMthCar', this.form)
					}
					if(res.data.code === 1) {
						this.$message.success('操作成功')
						this.$emit('success')
						this.handleClose()
					}else {
						this.$message.error(res.data.msg)
					}
				} catch (e) {
					this.$message.error(e.msg || '操作失败')
				} finally {
					this.loading = false
				}
			}
		}
	}
</script>

<style>
</style>